import StateSelect from "@/components/form/state-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type StateFieldExtraProps = {
  placeholder?: string;
  align?: "start" | "center" | "end";
  /**
   * Emitted as the hidden native select's `name`, which is how the browser
   * groups this control with the sibling address inputs for autofill. In terse
   * mode this is the form field name itself.
   */
  name?: string;
};

/** **Value is the two-letter state code**; `""` = nothing selected. */
export type StateFieldProps = PickerFieldProps<string, StateFieldExtraProps>;

export const StateField = makePickerField<string, StateFieldExtraProps>({
  name: "StateField",
  control: StateSelect,
  popout: true,
  controlProps: (props) => ({
    placeholder: props.placeholder,
    align: props.align,
    name: props.name,
  }),
});
